import styled from "styled-components"

interface ImageProps {
  isGif?: boolean
}

export const StyledImg = styled.img<ImageProps>`
  margin-left: ${({isGif, theme}) => (isGif ? theme.spacing.two : "0px")};
  width: ${({isGif}) => (isGif ? "50%" : "500px")};
  height: auto;
`
